export default function AboutSection() {
  return (
    <section className="py-12 sm:py-16 lg:py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-8">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 sm:gap-8">
          <div className="bg-gradient-to-br from-[#F5F5DC] to-[#FAF0E6] rounded-3xl p-6 sm:p-8 lg:p-10 space-y-4 sm:space-y-6 hover:shadow-xl transition-all">
            <div className="w-14 h-14 sm:w-16 sm:h-16 bg-[#E8F5E9] rounded-2xl flex items-center justify-center">
              <i className="ri-heart-line text-3xl sm:text-4xl text-[#66BB6A]"></i>
            </div>
            <h3 className="text-xl sm:text-2xl font-bold text-[#2C2C2C]">丁寧に、優しく</h3>
            <p className="text-sm sm:text-base text-[#757575] leading-relaxed">
              PC・Web操作が苦手な方も大丈夫。一つひとつ丁寧に、おひとりおひとりのペースに合わせてサポートします。
            </p>
          </div>
          <div className="bg-gradient-to-br from-[#F5F5DC] to-[#FAF0E6] rounded-3xl p-6 sm:p-8 lg:p-10 space-y-4 sm:space-y-6 hover:shadow-xl transition-all">
            <div className="w-14 h-14 sm:w-16 sm:h-16 bg-[#E8F5E9] rounded-2xl flex items-center justify-center">
              <i className="ri-team-line text-3xl sm:text-4xl text-[#66BB6A]"></i>
            </div>
            <h3 className="text-xl sm:text-2xl font-bold text-[#2C2C2C]">寄り添う伴走</h3>
            <p className="text-sm sm:text-base text-[#757575] leading-relaxed">
              「やってみたいけど不安」「続かない」そんな悩みに寄り添い、一緒に歩んでいきます。
            </p>
          </div>
          <div className="bg-gradient-to-br from-[#F5F5DC] to-[#FAF0E6] rounded-3xl p-6 sm:p-8 lg:p-10 space-y-4 sm:space-y-6 hover:shadow-xl transition-all md:col-span-2 lg:col-span-1">
            <div className="w-14 h-14 sm:w-16 sm:h-16 bg-[#E8F5E9] rounded-2xl flex items-center justify-center">
              <i className="ri-map-pin-line text-3xl sm:text-4xl text-[#66BB6A]"></i>
            </div>
            <h3 className="text-xl sm:text-2xl font-bold text-[#2C2C2C]">地域密着型</h3>
            <p className="text-sm sm:text-base text-[#757575] leading-relaxed">
              徒歩・自転車・5km圏内の地元事業者様を中心に、顔の見える関係でサポートします。
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
